export function readPusulaLabResults(value) {
  let data = value;
  if (typeof data === 'string') {
    try { data = JSON.parse(data); } catch { return null; }
  }
  const rows = Array.isArray(data) ? data : data?.results;
  return Array.isArray(rows) ? rows.filter(row => row && typeof row === 'object' && !Array.isArray(row)) : null;
}

export function labResultDisplay(row) {
  if (row.result == null || String(row.result).trim() === '') {
    if (row.status === 'Bekliyor') return 'Sonuç bekleniyor';
    if (row.status === 'Numune') return 'Numune aşamasında';
    return 'Sonuç bildirilmemiş';
  }
  return String(row.result);
}

export function labFlagDisplay(row) {
  if (row.is_critical === true) return { label: 'Kritik', color: 'error' };
  if (row.is_abnormal === true || ['NormalUstu', 'NormalAlti'].includes(row.result_flag)) {
    return { label: row.result_flag === 'NormalUstu' ? 'Yüksek' : row.result_flag === 'NormalAlti' ? 'Düşük' : 'Referans dışı', color: 'warning' };
  }
  if (row.result_flag === 'Normal' && row.result != null && String(row.result).trim()) return { label: 'Normal', color: 'success' };
  return { label: 'Değerlendirme yok', color: 'default' };
}

// Render source wall-clock timestamps without assuming the browser timezone.
export function labDateDisplay(value) {
  if (!value) return '—';
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}:\d{2}(?::\d{2})?)(.*)$/);
  return match ? `${match[3]}.${match[2]}.${match[1]} ${match[4]}${/[Z+-]/.test(match[5]) ? ` ${match[5]}` : ''}` : String(value);
}
